import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Swal from "sweetalert2";
import { useApp } from "../../hooks/useApp";
import { properties } from "../../utils/Properties_es";
import Loading from "../utils/Loading";
import Footer from "./Footer";
import Logo from "../../resources/images/logo-parval.png";
/*****************************************************************************
 * REVISION 1.0
 * Fecha: 22/12/2022
 *
 * @description componente template - home layout
 * @version 1.0
 *
 ****************************************************************************/
const HomeLayout = () => {
  const {
    authenticate,
    isLoading,
    errorMsg,
    resetErrorMsg,
    successMsg,
    resetSuccessMsg,
  } = useApp();

  if (authenticate) {
    return <Navigate to="/board/home" />;
  }

  if (errorMsg) {
    Swal.fire({
      title: errorMsg,
      text: "",
      icon: "error",
      confirmButtonText: properties.com_parval_label_button_ok_title,
    }).then(() => resetErrorMsg());
  }

  if (successMsg) {
    Swal.fire({
      title: successMsg,
      text: "",
      icon: "success",
      confirmButtonText: properties.com_parval_label_button_ok_title,
    }).then(() => resetSuccessMsg());
  }
  //set tittle
  document.title = "PARVAL | PORTAL ADMINISTRATIVO";
  return (
    <>
      {isLoading && (
        <Loading title={properties.com_parval_label_loading_title} />
      )}
      <div className="bgr-container pb-3">
        <div className="container">
          <div className="logo pt-4 text-center">
            <div className="rounded-circle m-auto logo-center">
              <img src={Logo} height="135" alt="" />
            </div>
          </div>
          <Outlet />
        </div>
      </div>
      <Footer footerType="login" />
    </>
  );
};
export default HomeLayout;
